import PremiacaoPanel from "@/components/PremiacaoPanel";
export default {
  name: "PremiacaoNivel",
  components: {
    PremiacaoPanel
  },
  props: {
    premiadosNivel: Object,
    nivel: Number
  }
};